import React, { useState } from 'react';
import { Form, Button, Alert, Container, Card } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ForcePasswordChange from './ForcePasswordChange';

const isMockAuth = process.env.REACT_APP_ENVIRONMENT === 'localstack';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [challengeUser, setChallengeUser] = useState(null);
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      const result = await signIn(username, password);
      if (!result.isSignedIn && result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        setChallengeUser(result);
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChangeComplete = () => {
    setChallengeUser(null);
    navigate('/');
  };

  if (challengeUser) {
    return (
      <ForcePasswordChange 
        user={challengeUser} 
        onComplete={handlePasswordChangeComplete} 
      />
    );
  }

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div style={{ maxWidth: '400px', width: '100%' }}>
        <Card data-testid="login-card">
          <Card.Body>
            <h2 className="text-center mb-4">Log In</h2>
            {isMockAuth && (
              <Alert variant="info" className="mb-3" data-testid="login-dev-mode-alert">
                <strong>Development Mode:</strong> Using mock authentication. Use{' '}
                <a 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    setUsername('test@localstack.com');
                  }}
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                  test@localstack.com
                </a>
                {' '}with any password.
              </Alert>
            )}
            {error && <Alert variant="danger" data-testid="login-error">{error}</Alert>}
            <Form onSubmit={handleSubmit} data-testid="login-form">
              <Form.Group id="username" className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  data-testid="login-username"
                />
              </Form.Group>
              <Form.Group id="password" className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="login-password"
                />
              </Form.Group>
              <Button disabled={loading} className="w-100" type="submit" data-testid="login-submit">
                Log In
              </Button>
            </Form>
            <div className="w-100 text-center mt-3">
              <Link to="/forgot-password" data-testid="login-forgot-password">Forgot Password?</Link>
            </div>
          </Card.Body>
        </Card>
        {/* <div className="w-100 text-center mt-2">
          Need an account? <Link to="/signup">Sign Up</Link>
        </div> */}
      </div>
    </Container>
  );
};

export default Login;